export const SUCCESS_STORIES_ROUTE = "/testimonials";
export const CONTACT_US_ROUTE = "/contact";
export const ABOUT_US_ROUTE = "/about-us";
export const PRICING_ROUTE = "/pricing";
export const HOW_IT_WORKS_ROUTE = "/how-it-works";
export const HOW_IT_WORKS_STUDENTS_ROUTE = "/s/how-it-works";
export const HOW_IT_WORKS_PROFESSIONALS_ROUTE = "/i/how-it-works";
export const PROFILES_ROUTE = "/profiles";
export const FAQS_STUDENTS_ROUTE = "/s/faqs";
export const FAQS_PROFESSIONAL_ROUTE = "/i/faqs";
export const TERMS_AND_CONDITIONS_ROUTE = "/terms-and-conditions";
export const PRIVACY_POLICY_ROUTE = "/privacy-policy";